import { render, staticRenderFns } from "./CreateNoticeForm.vue?vue&type=template&id=29ad9665&"
import script from "./CreateNoticeForm.vue?vue&type=script&lang=js&"
export * from "./CreateNoticeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports